import React, { useEffect, useMemo, useRef, useState } from "react";
import DataTable from "../../../components/common/datatable/DataTable";
import { useNavigate } from "react-router-dom";
import "../analyticsresults/AnalyticsResults.css";
import TopSection from "../TopSection";
import { useLocation } from "react-router-dom";
import { getViewAllDetailsEndpoint } from "../../../common/endpoints";
import { getAnalyticsWorkflowResults } from "../../../redux/actions/LTPlanner/AnalyticsWorkflowResultsSlice";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../../components/common/Loader";
import { getViewAllDetails } from "../../../redux/actions/ViewAllLineItemsDataSlice";
import { IconButton } from "@mui/material";
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import LeadtimeModel from "../analyticsresults/LeadTimeModal";
import { DPSAnalyticsTableHeaders } from "./DPSLTColumnHeader";

const DPSLTAnalyticsResults = () => {
    const dispatch = useDispatch();
    const stateSelector = useSelector((state) => state);
    const [rowData, setRowData] = useState([]);
    const { state } = useLocation();
    const gridRef = useRef();
    const [gridApi, setGridApi] = useState();
    const [openViewAllModal, setOpenViewAllModal] = useState(false);
    const [viewAllData, setViewAllData] = useState({});
    const [pageSize, setPageSize] = useState(500);
    const [currentPage, setCurrentPage] = useState(Number(localStorage.getItem("lastVisitedPage")) || 1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalPageItems, setTotalPageItems] = useState(0);
    const [totalItemCurrentPage, setTotalItemCurrentPage] = useState(0);

    useEffect(() => {
        getWorkFlowData("pendingActionItems");
    }, [currentPage, pageSize])

    const getWorkFlowData = async (endpoint) => {
        try {
            const responseAnaltics = await dispatch(getAnalyticsWorkflowResults({
                dynamicEndpoint: `api/lt/admin/${endpoint}`,
                params: {
                    page: currentPage,
                    size: pageSize,
                    plant: localStorage.getItem("selectedLTPlantCode")
                },
            }));
            if (responseAnaltics?.meta?.requestStatus === 'fulfilled') {
                gridApi?.deselectAll();
                setRowData(responseAnaltics?.payload?.records);
                setTotalPages(responseAnaltics?.payload?.totalPages);
                setTotalPageItems(responseAnaltics?.payload?.totalNumberOfItems);
                setTotalItemCurrentPage(responseAnaltics?.payload?.totalItemsInPage);
            } else {
                console.error('Failed to fetch data:', responseAnaltics?.error);
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    const navigate = useNavigate();

    const onGridReady = (params) => {
        setGridApi(params?.api);
    }

    const getViewAllData = async (row) => {
        try {
            const responseViewAllDetails = await dispatch(getViewAllDetails({
                dynamicEndpoint: `${getViewAllDetailsEndpoint}/${row.runSeqId}`,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responseViewAllDetails?.meta?.requestStatus === 'fulfilled') {
                setViewAllData(responseViewAllDetails?.payload)
            } else {
                console.error('Failed to fetch data:', responseViewAllDetails?.payload?.errorMessage);
                setViewAllData({})
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }
    const handleOpenViewAllModal = (row) => {
        setOpenViewAllModal(true);
        getViewAllData(row);
    }
    const handleCloseViewAllModal = (row) => {
        setOpenViewAllModal(false);
        setViewAllData({})
    }

    const regularItemsData = DPSAnalyticsTableHeaders(navigate, handleOpenViewAllModal)

    const selectionColumnDef = useMemo(() => ({
        pinned: 'left'
    }))

    const gridOptions = {
        getRowId: (params) => {
            return `${params?.data?.runOutputSeqId}`
        },
        overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
        overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
        defaultColDef: {
            sortable: true,
            filter: 'agMultiColumnFilter',
            filterParams: {
                filters: [
                    {
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            suppressMiniFilter: false,
                        },
                    },
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            excelMode: 'windows',
                            suppressMiniFilter: false,
                            buttons: ['apply', 'reset'],
                        },
                    },
                ],
            },
            autoHeight: true,
            cellStyle: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: 1.5,
                display: "flex",
                alignItems: "center",
            },
            valueGetter: (params) => {
                if (!params.data) return "-";

                const field = params.colDef.field;
                const value = params.data[field];

                return value === null || value === undefined || value === "" ? "-" : value;
            },
        }

    }

    const onPageSizeChanged = (event) => {
        setPageSize(Number(event.target.value));
        setCurrentPage(1); // Reset to first page
    };

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            localStorage.setItem("lastVisitedPage", page);
        }
    };

    const getRange = () => {
        const start = (currentPage - 1) * pageSize + 1;
        const end = Math.min(currentPage * pageSize, totalPageItems);
        return `${start} - ${end}`
    }

    return (
        (stateSelector?.AnalyticsWorkflowResultsSlice?.loading) ?
            <Loader />
            :
            <div>
                <TopSection tabTitle="DPS Analytics Results" labelList={[{ title: 'Home', path: '/landing-page' }, { title: 'DPS Analytics Results' }]} />
                <div
                    style={{
                        border: "1px solid lightgrey",
                        borderRadius: "6px",
                        padding: "10px",
                    }}
                >
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        {rowData &&
                            <div>
                                <DataTable
                                    ref={gridRef}
                                    columns={regularItemsData}
                                    rows={rowData || []}
                                    paginationProp={false}
                                    onGridReady={onGridReady}
                                    selectionColumnDef={selectionColumnDef}
                                    gridOptions={gridOptions}
                                />

                                <div className="customPagination_admin">
                                    <div className="pagSize_pagination_Admin">
                                        <p style={{ margin: '5px' }}>Page Size:</p>
                                        <select onChange={onPageSizeChanged} value={pageSize} style={{ width: '70px', borderRadius: '5px', borderColor: 'lightgray', padding: '5px' }}>
                                            <option value={10}>10</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                            <option value={500}>500</option>
                                            <option value={1000}>1000</option>
                                        </select>
                                    </div>
                                    <div style={{ margin: '0 25px' }}>
                                        <span>{`${getRange()} of ${totalPageItems}`}</span>
                                    </div>
                                    <div>
                                        <IconButton onClick={() => goToPage(1)} disabled={currentPage === 1} style={{ padding: 0 }}>
                                            <SkipPreviousIcon />
                                        </IconButton>
                                        <IconButton onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
                                            <ArrowLeftIcon />
                                        </IconButton>
                                        <span>{`Page ${currentPage} of ${totalPages}`}</span>
                                        <IconButton onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>
                                            <ArrowRightIcon />
                                        </IconButton>
                                        <IconButton onClick={() => goToPage(totalPages)} disabled={currentPage === totalPages} style={{ padding: 0 }}>
                                            <SkipNextIcon />
                                        </IconButton>
                                    </div>
                                </div></div>}
                        <div>
                            <LeadtimeModel data={viewAllData} openViewAllModal={openViewAllModal} loading={stateSelector?.ViewAllLineItemsDataSlice?.loading} handleCloseViewAllModal={handleCloseViewAllModal} />
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default DPSLTAnalyticsResults;
